import { MapPin, ExternalLink, Navigation } from "lucide-react";

export default function PropertyMap({ address, city, state, zip, height = "h-72" }) {
  const full = [address, city, state, zip].filter(Boolean).join(", ");
  if (!full) return <p className="text-sm text-slate-400">No address on file for this property.</p>;
  const q = encodeURIComponent(full);
  const embed = `https://maps.google.com/maps?q=${q}&z=15&output=embed`;
  const link = `https://www.google.com/maps/search/?api=1&query=${q}`;
  return (
    <div data-testid="property-map">
      <div className={`relative w-full ${height} rounded-lg overflow-hidden border border-slate-200`}>
        <iframe title="Property location" src={embed} className="w-full h-full" loading="lazy" referrerPolicy="no-referrer-when-downgrade" style={{ border: 0 }} />
      </div>
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 mt-3">
        <span className="flex items-center gap-1.5 text-sm text-slate-600"><MapPin className="w-4 h-4 text-gold-dark" />{full}</span>
        <a href={link} target="_blank" rel="noreferrer" data-testid="open-in-maps"
          className="ml-auto inline-flex items-center gap-1.5 text-sm font-medium text-navy-800 border border-slate-200 rounded-lg px-3 py-1.5 hover:border-gold hover:bg-slate-50 transition-[border-color,background-color]">
          <Navigation className="w-4 h-4 text-gold-dark" />Get Directions<ExternalLink className="w-3 h-3" />
        </a>
      </div>
    </div>
  );
}
